export default {
    // getBanner: (data) => window.axios.post('get_banner', data),
    getBanner: (data) => window.axios.post('banners', data),
    getBannerCategory: (data) => window.axios.post('banners/category', data),
    getBannerRestaurant: (data, banner_id) => window.axios.post(`banners/${banner_id}/restaurants`, data),
}